import styled from "styled-components";

import { Website } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledAppImg = styled.img`
    width: 26px;
    height: 26px;
    border-radius: 3px;
`;

export const StyledPlatformBadge = styled(Flex)`
    position: absolute;
    bottom: -4px;
    right: -4px;
    width: 16px;
    height: 16px;
    align-items: center;
    justify-content: center;
    background: ${colorsPalettes.carbon[0]};
    border-radius: 50%;
`;

export const StyledAppIconWrapper = styled.a`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${colorsPalettes.blue[400]};
        outline-offset: 2px;
    }

    &:hover {
        border-color: ${colorsPalettes.blue[400]};
    }
`;

export const StyledWebsiteIcon = styled(Website)``;

export const StyledDomainChipIcon = styled(Flex)`
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    width: 32px;
    height: 32px;

    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};
`;

export const StyledDomainChip = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px 4px 4px;

    color: ${colorsPalettes.carbon[500]};
    border-radius: 8px;
    background: ${colorsPalettes.carbon[25]};

    text-decoration: none;
    white-space: nowrap;

    &:hover {
        color: ${colorsPalettes.blue[400]};

        ${StyledDomainChipIcon} {
            border-color: ${colorsPalettes.blue[400]};
        }

        ${StyledWebsiteIcon} {
            color: ${colorsPalettes.blue[400]};
        }
    }
`;
